module.exports = __webpack_public_path__ + "prod/1.42.2/img/transfer-icon.9ef5fa50.png";